import { Box, Typography } from '@mui/material';
import { IProjectMembersAllocationData } from '../type';
import ProjectAllocationCard from './project-allocation-card';

export interface AllocationType {
  projectId: string;
  projectMemberId: string;
  currentAllocation: string;
  projectName: string;
  colorCode: string;
}

interface GridProps {
  members: IProjectMembersAllocationData[];
  value?: string;
}

export const ProjectAllocationGrid = ({ members }: GridProps): JSX.Element => {
  return (
    <>
      {members.length > 0 ? (
        <Box
          sx={{
            marginBottom: '10px'
          }}
        >
          {members.map((member: IProjectMembersAllocationData) => {
            return (
              <Box key={member.id}>
                <ProjectAllocationCard
                  project={member.projectName}
                  currentAllocation={member.hoursPerWeek}
                  colorCode={member.colorCode}
                />
              </Box>
            );
          })}
        </Box>
      ) : (
        <>
          <Typography
            sx={{
              fontFamily: 'Be Vietnam Pro',
              fontSize: '16px',
              fontWeight: 400,
              color: '#1A1B1F',
              textAlign: 'center',
              marginBottom: '20px'
            }}
          >
            No current allocations
          </Typography>
        </>
      )}
    </>
  );
};
